module.exports = __webpack_public_path__ + "static/media/toolbar_death_b_i.09855e54.png";